<template>
<div class="popup_overlay">
  <div class="custom_dialog_comp bg-white h-full" style="width:100%">
    <div class="cust_card_comp">
      <div class=" rounded px-5 py-4 h-full bg-primary text-white heading-2 font-bold flex items-center justify-between">
        <div>
          <p class="">hire_table</p>
        </div>
        <div>
          <button class="list_top_card_btn font-bold bg-gray-200 cta-text text-text1 py-2 px-4 mr-2 rounded-3xl" @click="closeDetails(false)">Discard</button>
          <button class="list_top_card_btn font-bold  bg-success cta-text text-white py-2 px-4 rounded-3xl" @click="saveData()">Save</button>
        </div>  
      </div>
  <div class="p-0 bg-white" >
    <div class="bg-white p-2">
      <div class="pt-2 px-1 grid grid-cols-2 gap-x-2">
        <div class="box bg-white h-full cust_card">
          <div>
            <div class="p-2 pb-0 grid grid-cols-12">
              <div class="box col-span-6 p-2 pb-0">
                <p class="label_css">heading</p>
                <textarea v-model="fieldJsonData.heading"
                :class="heading_err ? 'border border-error' : ''"
                class="outline-none  text-gray-900 text-sm rounded  block w-full pl-2 p-2.5 h-12 heading-4 border border-gray-500 focus:border-gray-800" 
                placeholder="heading"
                ></textarea>
                <p v-if="heading_err" class="text-error heading-6">heading is required</p>
              </div>
              <div class="box col-span-6 p-2 pb-0">
                <p class="label_css">description</p>
                <textarea v-model="fieldJsonData.description"
                class="outline-none  text-gray-900 text-sm rounded  block w-full pl-2 p-2.5 h-12 heading-4 border border-gray-500 focus:border-gray-800" 
                placeholder="description"
                ></textarea>
              </div>
            </div>
              <div  class="mt-4" style="border: 1px solid gray"></div> 
          </div>
          <div class="py-2 px-1 grid  gap-x-2">
            <p class="label_css pl-2 font-bold">card_list</p>
           <div v-for="(data, index) in fieldJsonData.card_list" :key="index" class="p-2 pb-0 grid grid-cols-12">
                <div class="box col-span-6 p-2 pb-0">
                    <p class="label_css">row_heading</p>
                    <input v-model="data.row_heading"
                    :class="data.row_heading_err ? 'border border-error' : ''"
                    class="outline-none  text-gray-900 text-sm rounded  block w-full pl-2 p-2.5 h-12 heading-4 border border-gray-500 focus:border-gray-800" 
                    placeholder="row_heading"
                    >
                    <p v-if="data.row_heading_err" class="text-error heading-6">row_heading is required</p>
                </div>
                <div class="box col-span-6 p-2 pb-0">
                    <p class="label_css">row_heading_back_color</p>
                    <input v-model="data.row_heading_back_color"
                    :class="data.row_heading_back_color_err ? 'border border-error' : ''"
                    class="outline-none  text-gray-900 text-sm rounded  block w-full pl-2 p-2.5 h-12 heading-4 border border-gray-500 focus:border-gray-800" 
                    placeholder="row_heading_back_color"
                    >
                    <p v-if="data.row_heading_back_color_err" class="text-error heading-6">row_heading_back_color is required</p>
                </div>
                <div class="box col-span-6 p-2 pb-0">
                    <p class="label_css">row_data</p>
                    <textarea v-model="data.row_data"
                    :class="data.row_data_err ? 'border border-error' : ''"
                    class="outline-none  text-gray-900 text-sm rounded  block w-full pl-2 p-2.5 h-12 heading-4 border border-gray-500 focus:border-gray-800" 
                    placeholder="row_data"
                    ></textarea>
                    <p v-if="data.row_data_err" class="text-error heading-6">row_data is required</p>
                </div>
                <div class="box col-span-6 p-2 pb-0">
                    <p class="label_css">row_data_back_color</p>
                    <input v-model="data.row_data_back_color"
                    class="outline-none  text-gray-900 text-sm rounded  block w-full pl-2 p-2.5 h-12 heading-4 border border-gray-500 focus:border-gray-800" 
                    placeholder="row_data_back_color"
                    >
                </div>
                <div class="box col-span-12 p-1 mt-3">
                <div class="flex justify-end">
                  <button v-if="index !== 0" class=" rounded-full h-8 w-8 bg-error  mr-1"
                    @click="removeCardDetails(index)"
                    >
                    <i class="fas fa-minus text-white heading-3"></i>
                  </button>
                  <button v-if="index === fieldJsonData.card_list.length - 1" class=" rounded-full h-8 w-8 bg-primary"
                  @click="addCardDetails()"
                    >
                    <i class="fas fa-plus text-white heading-3"></i>
                  </button>
                </div>
              </div>
                <div v-if="fieldJsonData.card_list.length - 1 !== index" class="mt-4 col-span-12" style="border: 1px solid gray; border-style: dashed"></div>
             </div>
             <div  class="mt-4" style="border: 1px solid gray"></div>
             <div class="p-2 pb-0 grid grid-cols-12">
              <p class="label_css pl-2 font-bold col-span-12">btn_text</p>
              <div class="box col-span-6 p-2 pb-0">
                <p class="label_css">button_text</p>
                <input v-model="fieldJsonData.button_text"
                :class="button_text_err ? 'border border-error' : ''"
                class="outline-none  text-gray-900 text-sm rounded  block w-full pl-2 p-2.5 h-12 heading-4 border border-gray-500 focus:border-gray-800" 
                placeholder="button_text"
                >
                <p v-if="button_text_err" class="text-error heading-6">button_text is required</p>
              </div>
              <div class="box col-span-6 p-2 pb-0">
                <p class="label_css">url_to_open</p>
                <input v-model="fieldJsonData.url_to_open"
                :class="url_to_open_err ? 'border border-error' : ''"
                class="outline-none  text-gray-900 text-sm rounded  block w-full pl-2 p-2.5 h-12 heading-4 border border-gray-500 focus:border-gray-800" 
                placeholder="url_to_open"
                >
                <p v-if="url_to_open_err" class="text-error heading-6">url_to_open is required</p>
              </div>
              <div class="box col-span-6 p-2 pb-0">
                <p class="label_css">button_background_color</p>
                <input v-model="fieldJsonData.button_background_color"
                class="outline-none  text-gray-900 text-sm rounded  block w-full pl-2 p-2.5 h-12 heading-4 border border-gray-500 focus:border-gray-800" 
                placeholder="button_background_color"
                >
              </div>
              <div class="box col-span-6 p-2 pb-0">
                <p class="label_css">button_text_color</p>
                <input v-model="fieldJsonData.button_text_color"
                class="outline-none  text-gray-900 text-sm rounded  block w-full pl-2 p-2.5 h-12 heading-4 border border-gray-500 focus:border-gray-800" 
                placeholder="button_text_color"
                >
              </div>
              <div class="col-span-12 mt-2 p-2 pb-0">
                <p class="label_css">cta_in_new_tab</p>
                <div class="flex items-center pb-1 ">
                  <input id="default-radio-3" v-model="fieldJsonData.open_in_new_tab" type="radio" :value="false" name="default-radio 3" class="w-5 h-5 text-primary bg-gray-100 border-gray-300 outline-none cursor-pointer">
                  <label for="default-radio-3" class="ml-2 heading-4 text-text2  dark:text-gray-300">No</label>
                </div>
                <div class="flex items-center pb-1 col-span-6">
                  <input id="default-radio-4" v-model="fieldJsonData.open_in_new_tab" type="radio" :value="true" name="default-radio 4" class="w-5 h-5 text-primary bg-gray-100 border-gray-300 outline-none cursor-pointer">
                  <label for="default-radio-4" class="ml-2 heading-4 text-text2  dark:text-gray-300">Yes</label>
                </div>
              </div>
             </div>
          </div>
          <!-- <div class="p-2 pb-5 text-right">
            <div>
              <button class="list_top_card_btn bg-gray-200 cta-text text-text1 py-2 px-4 mr-2 rounded-3xl">Discard</button>
              <button class="list_top_card_btn bg-primary cta-text text-white py-2 px-4 mr-2 rounded-3xl" @click="saveData()">Save</button>
            </div>  
          </div> -->
        </div>
        <div>
        <img style="padding: 1px"  class="box border-1 shadow-lg rounded-lg" :src="componentImageUrl" :alt="componentImageUrl" />
      </div>
      </div>
    </div>
  </div>
    </div>
  </div>
</div>
</template>
<script>
// import draggable from 'vuedraggable'
// import HRM from '@/View/CMS/api/HRM.js'
export default {
  components: {
    // draggable,
  },
  props: ['componentDetailsForEdit', 'fieldJsonData', 'componentImageUrl', 'componentId'],
  data () {
    return {
      heading_err: false,
      button_text_err: false,
      url_to_open_err: false,
      isError: true,
      // fieldJsonData: {
      //   component_name: "fieldJsonData",
      //   heading: "",
      //   description: "",
      //   card_list: [
      //       {
      //       row_data: "",
      //       row_data_err: false,
      //       row_data_back_color: "",
      //       row_heading: "",
      //       row_heading_err: false,
      //       row_heading_back_color: "",
      //       row_heading_back_color_err: false,
      //       },
      //       {
      //       row_data: "",
      //       row_data_err: false,
      //       row_data_back_color: "",
      //       row_heading: "",
      //       row_heading_err: false,
      //       row_heading_back_color: "",
      //       row_heading_back_color_err: false,
      //       },
      //       {
      //       row_data: "",
      //       row_data_err: false,
      //       row_data_back_color: "",
      //       row_heading: "",
      //       row_heading_err: false,
      //       row_heading_back_color: "",
      //       row_heading_back_color_err: false,
      //       },
      //       {
      //       row_data: "",
      //       row_data_err: false,
      //       row_data_back_color: "",
      //       row_heading: "",
      //       row_heading_err: false,
      //       row_heading_back_color: "",
      //       row_heading_back_color_err: false,
      //       },
      //       {
      //       row_data: "",
      //       row_data_err: false,
      //       row_data_back_color: "",
      //       row_heading: "",
      //       row_heading_err: false,
      //       row_heading_back_color: "",
      //       row_heading_back_color_err: false,
      //       }
      //   ],
      //   button_text: {
      //     button_background_color: null,
      //     button_text: "",
      //     button_text_color: null,
      //     open_in_new_tab: false,
      //     url_to_open: ""
      //   }
      // }
    }
  },
  created() {
    if (this.componentDetailsForEdit !== null) {
      console.log("componentDetailsForEdit!!!!!!!!!!!fieldJsonData", this.componentDetailsForEdit)
      this.fieldJsonData = this.componentDetailsForEdit
      console.log("this.fieldJsonData", this.fieldJsonData)
    }
  },
  mounted () {
  },
  watch: {
    fieldJsonData: {
      handler () {
        console.log('fieldJsonData 123', this.fieldJsonData)
        if (this.fieldJsonData.heading !== '') {
          this.heading_err = false
          this.isError = false
        }
        if (this.fieldJsonData.button_text !== '') {
          this.button_text_err = false
          this.isError = false
        }
        if (this.fieldJsonData.url_to_open !== '') {
          this.url_to_open_err = false
          this.isError = false
        }
        for (let index = 0; index < this.fieldJsonData.card_list.length; index++) {
          if (this.fieldJsonData.card_list[index].row_heading !== '') {
            this.fieldJsonData.card_list[index].row_heading_err = false
            this.isError = false
          }
          if (this.fieldJsonData.card_list[index].row_heading_back_color !== '') {
            this.fieldJsonData.card_list[index].row_heading_back_color_err = false
            this.isError = false
          }  
          if (this.fieldJsonData.card_list[index].row_data !== '') {
            this.fieldJsonData.card_list[index].row_data_err = false
            this.isError = false
          }
        }
      },
      deep: true
    }
  },
  methods: {
    addCardDetails () {
      this.fieldJsonData.card_list.push({
        row_data: "",
        row_data_err: false,
        row_data_back_color: "",
        row_heading: "",
        row_heading_err: false,
        row_heading_back_color: "",
        row_heading_back_color_err: false,
      })
      console.log("addddddd", this.fieldJsonData.card_list);
    },
    removeCardDetails (index) {
      if (this.fieldJsonData.card_list.length !== 1) {
        this.fieldJsonData.card_list.splice(index, 1)
      }
      console.log("removeeeeeee", this.fieldJsonData.card_list);
    },
    saveData() {
      console.log("componentDetailsForEdit", this.componentDetailsForEdit)
      if (this.fieldJsonData.heading === '') {
        this.heading_err = true
        this.isError = true
      }
      if (this.fieldJsonData.button_text === '') {
        this.button_text_err = true
        this.isError = true
      }
      if (this.fieldJsonData.url_to_open === '') {
          this.url_to_open_err = true
          this.isError = true
      }
      for (let index = 0; index < this.fieldJsonData.card_list.length; index++) {
          if (this.fieldJsonData.card_list[index].row_heading === '') {
            this.fieldJsonData.card_list[index].row_heading_err = true
            this.isError = true
          }
          if (this.fieldJsonData.card_list[index].row_heading_back_color === '') {
            this.fieldJsonData.card_list[index].row_heading_back_color_err = true
            this.isError = true
          }
          if (this.fieldJsonData.card_list[index].row_data === '') {
            this.fieldJsonData.card_list[index].row_data_err = true
            this.isError = true
          }
      }
      if (this.isError === false) {
        for (let index = 0; index < this.fieldJsonData.card_list.length; index++) {
            delete this.fieldJsonData.card_list[index].heading_err
            delete this.fieldJsonData.card_list[index].row_heading_err
            delete this.fieldJsonData.card_list[index].row_heading_back_color_err
            delete this.fieldJsonData.card_list[index].row_data_err
        }
        this.$emit('objData', this.fieldJsonData)
        this.componentDetailsForEdit = null
        let compIdImage = {
          imageUrl: this.componentImageUrl,
          id: this.componentId
        }
        // this.$emit('imageData', this.componentImageUrl)
        this.$emit('compIdImage', compIdImage)
        this.$root.$emit('closeComponentDialog', true)
        console.log("this.fieldJsonData............", this.fieldJsonData)
      }
    },
    closeDetails () {
    this.$root.$emit('closeComponentDialog', true)
    },
  },
  beforeDestroy () {
  }
}
</script>
<style scoped>
/* .list_top_card_btn {
  width: 163px !important;
  margin-right: 15px !important;
} */

::placeholder {
  font-size: 16px;
}
</style>